import {
  Card,
  Center,
  Stack,
  Text,
  ThemeIcon,
  useMantineTheme
} from '@mantine/core'
import { IconCpu2 } from '@tabler/icons-react'
import { OnlineStatus } from '../../../../devices/OnlineStatus/OnlineStatus'
import { SelectableCard } from '../../../../ui-shared/SelectableCard/SelectableCard'

type SelectableDeviceCardProps = {
  name: string
  isActive: boolean
  isSelected?: boolean
  disabled?: boolean
  onClick?: () => void
}

export const SelectableDeviceCard = ({
  name,
  isActive,
  isSelected,
  disabled,
  onClick
}: SelectableDeviceCardProps) => {
  const theme = useMantineTheme()

  return (
    <SelectableCard
      height={theme.other.deploymentCardHeight}
      isSelected={isSelected}
      disabled={disabled}
      onClick={onClick}
    >
      <Card.Section withBorder>
        <Center h={120} bg={isActive ? 'green.0' : 'red.1'}>
          <ThemeIcon size="xl" variant="light" radius="xl">
            <IconCpu2 style={{ width: '70%', height: '70%' }} />
          </ThemeIcon>
        </Center>
      </Card.Section>

      <Card.Section py="sm" pos="relative" inheritPadding>
        <Stack align="center" gap="xs">
          <Text ta="center" size="sm" fw="bold" lineClamp={2}>
            {name}
          </Text>

          <OnlineStatus status={isActive ? 'online' : 'offline'} />
        </Stack>
      </Card.Section>
    </SelectableCard>
  )
}
